export const FEATURE_NAME = '@zerops/zerops/feature/service-stack-form/modules/golang-service-stack-form';
